export default __webpack_public_path__ + "static/media/noticeBoard2.ae1bbfa7.png";